
/*
// jQuery: initParsedContent
// Parsed Content is used for the display of the Our Top Deals parseable slideshow on the homepage
// Clicking on a prase control performs some animation and then manipulates a set of parse content to display
//
// MINOR MODIFICATIONS - The following lines were commented out for responsive reasons
// Instead of detaching the objects from the DOM, we instead hide them, and add a responsive CSS class of "display: block !important" at the necessary media level
// so that all of the items will stack on top of each other, and remove the prev/next controls, and scrolling feature at that media query level
//
// LINES REMOVED
// ------------------------------------------
// if (index > 0) { $(this).detach(); }
// currParse.detach();
// newParse.appendTo($parseContainer).hide();
// ------------------------------------------
*/

jQuery(function initParsedContent($) {
	$('.js-parsed-content-container').each(function(index, el) {

		// Containers and Content Containers
		var $container              = $(this);
		var $parseContainer         = $container.find('.js-parse');
		var $parseContent           = $container.find('.js-parse-content');
		var $prevControl            = $container.find('.control-prev');
		var $nextControl            = $container.find('.control-next');
		var $parseCarouselIndicator = $container.find('.js-parse-carousel-indicator');

		// Index Management Variables
		var currParseIndex        = 0;
		var numParses             = $parseContent.length;
		var maxParseIndex         = $parseContent.length - 1;

		// Miscellaneous Variables
		var isTransitioning       = false;
		var defaultDuration       = 300;
		var fadeParameters        = {duration: defaultDuration, queue: false};
		var autoTabTransitionTime = 6000;
		var automateTabs          = '';
		var autoplay              = $container.data('autoplay');

		var initializeWidget = function() {

			// Hide all but the first element
			$parseContent.not(":eq(0)").hide();

			// Create click event for Previous Control
			$prevControl.each(function() {
				$(this).click(function(event) {
					transitionPreviousContent('prev', true);
				});
			});

			// Create click event for Previous Control
			$nextControl.each(function() {
				$(this).click(function(event) {
					transitionPreviousContent('next', true);
				});
			});

			// Create click event for All Carousel Indicators
			$parseCarouselIndicator.on('click', function() {
				$goToControl = $(this);
				transitionGoToContent($goToControl.data('go-to'), true);
			});
		};

		var transitionPreviousContent = function(direction, autoPlaySwitch) {
			if (!isTransitioning) {

				// If the user has clicked a control for a specific tab, disable the autoPlay
				if (autoPlaySwitch) {
					stopAutoplay();
				}

				isTransitioning = true;
				var $currParse = $($parseContent[currParseIndex]);
				var parseIndex = currParseIndex;
				var newParseIndex;

				if (direction === 'next') {
					parseIndex = parseIndex + 1;
				} else {
					parseIndex = parseIndex - 1;
				}

				if (parseIndex > maxParseIndex) {
					newParseIndex = 0;
				} else if (parseIndex < 0) {
					newParseIndex = maxParseIndex;
				} else {
					newParseIndex = parseIndex;
				}

				$currParse.fadeOut($.extend({}, fadeParameters, {
					complete: function() {
						//$currParse.detach();
						transitionNewContent(newParseIndex);
					}
				}));

				// Carousel Indicators transitioning per clicking on Previous/Next controls.
				// Use the default duration time for the easing transtion.
				transitionCarouselIndicators(currParseIndex, newParseIndex, defaultDuration);
			}
		};

		var transitionGoToContent = function(goToIndex, autoPlaySwitch) {
			if (!isTransitioning) {

				// If the user has clicked a specific control, disable the autoPlay
				if (autoPlaySwitch) {
					stopAutoplay();
				}

				isTransitioning = true;
				var currParseIndex = $parseCarouselIndicator.filter('.parse-carousel-indicator-current').data('go-to');
				var $currParse = $($parseContent[currParseIndex]);
				var newParseIndex = goToIndex;

				$currParse.fadeOut($.extend({}, fadeParameters, {
					complete: function() {
						transitionNewContent(newParseIndex);
					}
				}));

				// Carousel Indicators transitioning per clicking on a specific carousel indicator.
				// Set duration time to zero for transition (i.e. immediate switching be previous and new indicator).
				transitionCarouselIndicators(currParseIndex, newParseIndex, 0);
			}
		};

		var transitionCarouselIndicators = function(currParseIndex, newParseIndex, duration) {

			$($parseCarouselIndicator[currParseIndex]).switchClass( "parse-carousel-indicator-current", "parse-carousel-indicator", duration, "easeInOutQuad",
				function() {
					$($parseCarouselIndicator[newParseIndex]).switchClass( "parse-carousel-indicator", "parse-carousel-indicator-current", duration, "easeInOutQuad" );
				}
			);
		};

		var transitionNewContent = function(parseIndex) {
			var $newParse = $($parseContent[parseIndex]);
			//$newParse.appendTo($parseContainer).hide();

			$newParse.fadeIn($.extend({}, fadeParameters, {
				complete: function() {
					currParseIndex = parseIndex;
					isTransitioning = false;
				}
			}));
		};

		var startAutoplay = function() {
			automateTabs = setInterval(tabTimer, autoTabTransitionTime);
		};

		var stopAutoplay = function() {
			clearInterval(automateTabs);
		};

		var tabTimer = function() {
			transitionPreviousContent('next', false);
		};

		var hideControls = function() {
			// Hide the visibility of the control buttons so they retain their layout in the dom
			$prevControl.css('visibility','hidden');
			$nextControl.css('visibility','hidden');

			// Set 'isTransitioning' permanently to true to prevent usage of the controls
			isTransitioning = true;
		};

		if (numParses > 0) {
			initializeWidget();

			if (numParses > 1) {
				if (autoplay === 'yes') {
					startAutoplay();
				}
			} else {
				hideControls();
			}
		}
	});
});